export type CreatePageTemplateInsertion = {
  id: string
  body: string
  start: number
  end: number
}

export function appendCreatePageTemplateInsertion(
  prompt: string,
  id: string,
  body: string,
): {
  text: string
  insertion: CreatePageTemplateInsertion
} | null {
  const fragment = body.trim()
  if (!fragment) return null
  const base = prompt.trim()
  const prefix = base ? `${base}\n` : ''
  const start = prefix.length
  return {
    text: `${prefix}${fragment}`,
    insertion: {
      id,
      body: fragment,
      start,
      end: start + fragment.length,
    },
  }
}

export function removeCreatePageTemplateInsertion(
  prompt: string,
  insertion: CreatePageTemplateInsertion,
): {
  text: string
  removedStart: number
  removedEnd: number
} | null {
  if (prompt.slice(insertion.start, insertion.end) !== insertion.body) {
    return null
  }
  const removedStart =
    insertion.start > 0 && prompt[insertion.start - 1] === '\n'
      ? insertion.start - 1
      : insertion.start
  return {
    text: prompt.slice(0, removedStart) + prompt.slice(insertion.end),
    removedStart,
    removedEnd: insertion.end,
  }
}
